import { Component, OnInit, forwardRef, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, AbstractControl, ValidationErrors, FormGroup, FormControl, Validators, ControlValueAccessor, Validator, NG_VALIDATORS, FormArray, FormBuilder } from '@angular/forms';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { PasswordStrengthValidator } from 'src/app/front-user/shared/validator/password-strength.validators';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AgentCertificate } from '../shared/models/agent-certificate.model';
import { AgentInfo } from '../shared/models/agent.model';
import { TranslateService } from '@ngx-translate/core';

import { fileService } from 'src/app/front-user/shared/services/file.service';
import { ActivatedRoute } from '@angular/router';
import { AgentService } from '../shared/services/agent.service';
import { CertificateTypes, Languages, ServiceStatus, FormMode, Service } from 'src/app/shared/models/enums.model';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { debounceTime } from 'rxjs/operators';
import { MembershipService } from '../shared/services/membership.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/shared/services/app.config';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';

@Component({
  selector: 'agent-form',
  templateUrl: './agent-registration.component.html',
  styleUrls: ['./agent-registration.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgentRegistrationComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AgentRegistrationComponent),
      multi: true
    }
  ]
})

export class AgentRegistrationComponent implements OnInit, ControlValueAccessor, Validator {

  error: any = { isError: false, errorMessage: '' };
  public isTabOneSubmitted: boolean = false;

  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;

  uploadFolder = AppConfig.settings.apiServer.EBookingUploadsFolder;
  userNameError: any = { isError: false, errorMessage: '' };
  agentForm: FormGroup;
  genericLookupModel: GenericLookup[] = [];
  public agentInfo: AgentInfo = new AgentInfo();

  public updatedAgentInfo: AgentInfo = new AgentInfo();
  dropdownSettings = {};
  selectedItems = [];
  public agentCertificate: AgentCertificate[] = [];
  ShippingProgress: number;
  TaxCardProgress: number;
  taxCardAppendixProgress: number;
  taxAuthorizationProgress: number;
  commercialRecordProgress: number;
  otherDocumentsProgress: number;
  CertificateDate: Date;
  agentId: string = '';
  licensingsShipping: AgentCertificate = new AgentCertificate();
  taxCard: AgentCertificate = new AgentCertificate();
  taxCardAppendix: AgentCertificate = new AgentCertificate();
  taxAuthorization: AgentCertificate = new AgentCertificate();
  commercialRecord: AgentCertificate = new AgentCertificate();
  otherDocuments: AgentCertificate = new AgentCertificate();
  @ViewChild('tabOne',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwo',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('tabThree',{static: false}) tabThreeControls: ElementRef;
  private responseObj: ResponseObject = new ResponseObject();
  public CertificateTypes: any = CertificateTypes;
  @Output() agentEvent = new EventEmitter<AgentInfo>();
  @Output() getRepresentativeUserName = new EventEmitter<string>();
  @Output() isTabOneValid = new EventEmitter<boolean>();
  @Output() isTabTwoValid = new EventEmitter<boolean>();

  // @Output() isTabThreeValid = new EventEmitter<boolean>();

  // @Output() isShowSubmit = new EventEmitter<boolean>();
  @Output() updatedAgentEvent = new EventEmitter<AgentInfo>();

  numberRegex: string = '^[0-9]*$';
  public Languages: any = Languages;
  @Input() public formSubmitted: boolean;
  @ViewChild('agentTabs',{static: false}) agentTabs: TabsetComponent;

  @Input() public RequestStatus: number;

  public FormMode: any = FormMode;
  formMode = FormMode.Add;
  baseRequestDTO: any;
  // isTabOneValid: boolean =false;
  isTabTwoSubmitted: boolean = false;

  user: User = new User();
  emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
  displayedLang: Languages;
  constructor(
    private lookupService: LookupService,
    private translate: TranslateService, private fileService: fileService,
    private route: ActivatedRoute, private agentService: AgentService, private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private authSrevice: AuthenticationService,
    private membershipService: MembershipService, private baseRequestService: BaseRequestService
  ) {
    this.user = this.authSrevice.currentUserValue;
    this.displayedLang = this.globalSrv.getLanguage();
    //this.agentId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.agentId = history.state.data.requestId;
    } else if (this.route.snapshot.queryParams.UserID) {
      this.agentId = this.route.snapshot.queryParams.UserID;
    }
    this.buildForm();
  }


  ngOnInit() {
    //this.agentId ? this.agentForm.disable() : null;
    if (this.agentId) {
      this.baseRequestService.getByRequestorId(this.agentId, Service.AgentRegisteration).subscribe(
        d => {
          this.baseRequestDTO = d.Data;
          this.RequestStatus = this.baseRequestDTO.StatusId;
          if (history.state.data && history.state.data.isCompleted) {
            this.agentForm.disable();
            this.agentForm.get('agentRepresentative').disable();
            this.agentForm.get('agentCertificate').disable();
            this.agentForm.get('agentCurrency').disable();
            this.formMode = FormMode.Readonly;
          }
          else if (this.RequestStatus == ServiceStatus.MoreInformationRequestedFromAgent && this.user.UserId == this.agentId) {
            this.agentForm.enable();
            this.agentForm.get('agentRepresentative').enable();
            this.agentForm.get('agentCertificate').enable();
            this.agentForm.get('agentCurrency').enable();
            this.formMode = FormMode.Edit;
          }
          else if (this.RequestStatus == ServiceStatus.PendingonRegistrationAdminApproval && this.user.IsAdmin) {
            this.agentForm.disable();
            this.agentForm.get('agentRepresentative').disable();
            this.agentForm.get('agentCertificate').enable();
            this.agentForm.get('agentCurrency').disable();
            this.formMode = FormMode.Readonly;
          }

          else {
            this.agentForm.disable();
            this.agentForm.get('agentRepresentative').disable();
            this.agentForm.get('agentCertificate').disable();
            this.agentForm.get('agentCurrency').disable();
            this.formMode = FormMode.Readonly;
          }
          if (this.formMode == FormMode.Readonly || this.formMode == FormMode.Edit) {
            this.agentTabs.tabs[1].disabled = false;
            this.agentTabs.tabs[2].disabled = false;
          }
        });

      this.editAgent();
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.translate.instant('FRONT_USER.SELECT_ALL'),
      unSelectAllText: this.translate.instant('FRONT_USER.UN_SELECT_ALL'),
      allowSearchFilter: true
    };

    this.lookupService.getCurrencies()
      .subscribe((data: ResponseObject) => {
        this.genericLookupModel = data.Data as GenericLookup[];
      });
  }

  ngAfterViewInit() {
    if (this.agentTabs?.tabs?.length > 0) {
      this.agentTabs.tabs[1].disabled = !this.agentTabs.tabs[1].disabled;
      this.agentTabs.tabs[2].disabled = !this.agentTabs.tabs[2].disabled;
    }
  }

  get f() {
    return this.agentForm.controls;
  }

  get getAgentRepresentativesGetter() {
    return this.agentForm.controls["agentRepresentative"].value;
  }

  get getAgentRepresentativesLengthGetter() {
    return this.getAgentRepresentativesGetter.length;
  }




  buildForm() {
    this.agentForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),
      displayName: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),
      address: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),
      phone1: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
      phone2: new FormControl('', Validators.pattern(this.numberRegex)),
      fax: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
      contactPerson: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),

      agentCurrency: new FormGroup({
        currencyId: new FormControl('', Validators.required)
      }),

      agentCertificate: new FormGroup({
        // licensingsShippingUrl: new FormControl('', Validators.required),
        licensingsShippingUrl: new FormControl("", [FileValidator.validate]),
        shippingExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        licensingsShippingId: new FormControl(''),
        taxCardUrl: new FormControl("", [FileValidator.validate]),
        taxCardExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        taxCardId: new FormControl(''),
        taxCardAppendixUrl: new FormControl(''),
        taxCardAppendixExpirationDate: new FormControl(''),
        taxCardAppendixId: new FormControl(''),
        taxAuthorizationUrl: new FormControl("", [FileValidator.validate]),
        taxAuthorizationExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        taxAuthorizationId: new FormControl(''),
        commercialRecordUrl: new FormControl("", [FileValidator.validate]),
        commercialRecordExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        commercialRecordId: new FormControl(''),
        otherDocumentsUrl: new FormControl(''),
        otherDocumentsExpirationDate: new FormControl(''),
        otherDocumentsId: new FormControl(''),
      }),
      agentRepresentative: this.formBuilder.array([]),

    });
    if (!this.agentId) {
      this.addRepresentative();
    }

    // if(this.RequestStatus ==ServiceStatus.MoreInformationRequestedFromAgent){
    //     this.agentForm.addControl('MoreInformation', new FormControl());
    // }
  }

  addRepresentative() {
    let control = <FormArray>this.agentForm.controls['agentRepresentative'];
    control.push(new FormGroup({
      username: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
      password: new FormControl('', [Validators.required, PasswordStrengthValidator]),
      nationalId: new FormControl('', [Validators.required, Validators.pattern(/^(\d{14})$/)]),
      UserId: new FormControl('')
    }));
  }

  //#region CVA starts
  private valueChanges: Subscription;
  public onTouched: () => void = () => { };

  writeValue(val: any): void {
    val && this.agentForm.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.agentForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.agentForm.disable() : this.agentForm.enable();
  }
  registerOnValidatorChange(fn: () => void): void {
    this.agentForm.statusChanges.subscribe(fn);
  }
  validate(c: AbstractControl): ValidationErrors | null {
    //return this.agentForm.valid ? null : { invalidForm: {valid: false, message: "agent form fields are invalid"}};
    return this.agentForm.valid ? null : this.agentForm.controls;
  }
  //#endregion



  public async onFileSelected(event, certType: number, progressVariableName, currFormControl, key) {
    let localizationKeyValue = await this.translate.get(key).toPromise();

    var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
    this.alertService.clear();
    this[progressVariableName] = 0;
    let percentDone = 0;
    var formControlName = event.target.attributes['formControlName'].value;
    if (certType === CertificateTypes.OtherDocuments && formGroup["controls"]["otherDocumentsUrl"].value.length == 0) {
      formGroup["controls"]["otherDocumentsExpirationDate"].clearValidators();
      formGroup["controls"]["otherDocumentsExpirationDate"].updateValueAndValidity();
      // const index: number = this.data.indexOf(msg);
      // if (index !== -1) {
      //     this.data.splice(index, 1);
      // }
    }
    // else{
    //   formGroup["controls"]["otherDocumentsExpirationDate"].clearValidators();
    //   formGroup["controls"]["otherDocumentsExpirationDate"].updateValueAndValidity();
    // }

    if (certType === CertificateTypes.Taxcardappendix && formGroup["controls"]["taxCardAppendixUrl"].value.length == 0) {
      formGroup["controls"]["taxCardAppendixExpirationDate"].clearValidators();
      formGroup["controls"]["taxCardAppendixExpirationDate"].updateValueAndValidity();

    }
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      //this.agentForm.controls['agentCertificate'].get(formControlName).setValue("");
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;

    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      //let donName = file.name.split(".").pop();
      let donName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', donName);

      formData.append('FolderName', this.uploadFolder); //New Line
      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            percentDone = Math.round(100 * event.loaded / event.total)

            // console.log(`File is ${percentDone}% uploaded.`);

            this[progressVariableName] = percentDone;
            //this.agentForm.controls['agentCertificate'].get(formControlName).setErrors({ 'invalid': true });
            currFormControl.setErrors({ notCompleted: true });
          } else if (event instanceof HttpResponse) {

            // this.agentForm.controls['agentCertificate'].get(formControlName).setErrors(null);
            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            // console.log("json resp:" + jsonResponse);
            var certificate = new AgentCertificate();
            certificate.URL = Url;
            certificate.NameAR = file.name;
            certificate.NameEN = file.name;
            certificate.CertificateType = certType;
            certificate.Size = file.size;
            if (certType === CertificateTypes.OtherDocuments) {
              formGroup["controls"]["otherDocumentsExpirationDate"].setValidators([Validators.required, CustomValidators.dateValidator()]);
              formGroup["controls"]["otherDocumentsExpirationDate"].updateValueAndValidity();
            }
            if (certType === CertificateTypes.Taxcardappendix) {

              formGroup["controls"]["taxCardAppendixExpirationDate"].setValidators([Validators.required, CustomValidators.dateValidator()]);
              formGroup["controls"]["taxCardAppendixExpirationDate"].updateValueAndValidity();
            }
            if (this.formMode == FormMode.Edit) {
              certificate.Id = this.setCertificateIds(certType);
              if (!certificate.Id) {
                this.updatedAgentInfo.AgentCertificates = this.updatedAgentInfo.AgentCertificates.filter(h => h.CertificateType !== certType);
                this.updatedAgentInfo.AgentCertificates.push(certificate);
              } else {
                this.updatedAgentInfo.AgentCertificates.forEach((key: any, vals: any) => {
                  if (key.Id == certificate.Id) {
                    key.URL = certificate.URL
                    key.NameAR = certificate.NameAR
                    key.NameEN = certificate.NameEN
                    key.CertificateType = certificate.CertificateType
                    key.Size = certificate.Size
                  }
                });
              }
            }
            if (this.formMode == FormMode.Add) {
              this.agentCertificate = this.agentCertificate.filter(h => h.CertificateType !== certType);
              this.agentCertificate.push(certificate);
            }
            currFormControl.setErrors(null);

          }
          if (this.formMode == FormMode.Edit) {
            this.updatedAgentEvent.emit(this.updatedAgentInfo);
          }


        }

      );
    }
  }

  setCertificateIds(certificateType) {
    if (certificateType === CertificateTypes.shippingLicensing) {
      return this.licensingsShipping.Id;
    }
    if (certificateType === CertificateTypes.TaxAuthorization) {
      return this.taxAuthorization.Id;
    }
    if (certificateType === CertificateTypes.Taxcard) {
      return this.taxCard.Id;
    }
    if (certificateType === CertificateTypes.OtherDocuments && this.otherDocuments) {
      return this.otherDocuments.Id;
    }
    if (certificateType === CertificateTypes.Taxcardappendix && this.taxCardAppendix) {
      return this.taxCardAppendix.Id;
    }
    if (certificateType === CertificateTypes.CommercialRecord) {
      return this.commercialRecord.Id;
    }
  }
  public editAgent() {
    this.agentService.GetAgent(this.agentId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.isTabOneValid.emit(true);
          this.isTabTwoValid.emit(true);
          if (this.displayedLang == Languages.Arabic) {
            this.agentForm.patchValue({
              name: resObj.Data['Name'],
              displayName: resObj.Data['DisplayName'],
              address: resObj.Data['Address'],
              phone1: resObj.Data['Phone1'],
              phone2: resObj.Data['Phone2'],
              fax: resObj.Data['Fax'],
              contactPerson: resObj.Data['ContactPerson'],
              agentCurrency: {
                currencyId:
                  resObj.Data['AgentCurrencies'].map(function (obj) {
                    return {
                      Id: obj.Currency.Id,
                      NameAR: obj.Currency.NameAR,
                      AgentCurrencyId: obj.Id
                    }
                  }),
              }
            });
          }
          else {
            this.agentForm.patchValue({
              name: resObj.Data['Name'],
              displayName: resObj.Data['DisplayName'],
              address: resObj.Data['Address'],
              phone1: resObj.Data['Phone1'],
              phone2: resObj.Data['Phone2'],
              fax: resObj.Data['Fax'],
              contactPerson: resObj.Data['ContactPerson'],
              agentCurrency: {
                currencyId:
                  resObj.Data['AgentCurrencies'].map(function (obj) {
                    return {
                      Id: obj.Currency.Id,
                      NameEN: obj.Currency.NameEN,
                      AgentCurrencyId: obj.Id
                    }
                  }),
              }
            });
          }
          let element: HTMLElement = document.getElementsByTagName('Html')[0] as HTMLElement;
          element.click();
          var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          this.licensingsShipping = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.shippingLicensing);
          this.taxCard = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.Taxcard);
          this.taxCardAppendix = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.Taxcardappendix);
          this.taxAuthorization = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.TaxAuthorization);
          this.commercialRecord = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.CommercialRecord);
          this.otherDocuments = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.OtherDocuments);

          formGroup["controls"]["shippingExpirationDate"].setValue(new Date(this.licensingsShipping.ExpirationDate));
          formGroup["controls"]["licensingsShippingId"].setValue(this.licensingsShipping.Id);

          formGroup["controls"]["taxCardExpirationDate"].setValue(new Date(this.taxCard.ExpirationDate));
          formGroup["controls"]["taxCardId"].setValue(this.taxCard.Id);
          if (this.taxCardAppendix) {
            formGroup["controls"]["taxCardAppendixExpirationDate"].setValue(new Date(this.taxCardAppendix.ExpirationDate));
            formGroup["controls"]["taxCardAppendixId"].setValue(this.taxCardAppendix.Id);

          }

          //var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          formGroup["controls"]["taxAuthorizationExpirationDate"].setValue(new Date(this.taxAuthorization.ExpirationDate));
          formGroup["controls"]["taxAuthorizationId"].setValue(this.taxAuthorization.Id);
          //var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          formGroup["controls"]["commercialRecordExpirationDate"].setValue(new Date(this.commercialRecord.ExpirationDate));
          formGroup["controls"]["commercialRecordId"].setValue(this.commercialRecord.Id);
          //var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          if (this.otherDocuments) {
            formGroup["controls"]["otherDocumentsExpirationDate"].setValue(new Date(this.otherDocuments.ExpirationDate));
            formGroup["controls"]["otherDocumentsId"].setValue(this.otherDocuments.Id);
          }
          if (this.formMode == FormMode.Edit) {
            formGroup["controls"]["licensingsShippingUrl"].clearValidators();
            formGroup["controls"]["licensingsShippingUrl"].updateValueAndValidity();
            formGroup["controls"]["taxCardUrl"].clearValidators();
            formGroup["controls"]["taxCardUrl"].updateValueAndValidity();
            formGroup["controls"]["taxAuthorizationUrl"].clearValidators();
            formGroup["controls"]["taxAuthorizationUrl"].updateValueAndValidity();
            formGroup["controls"]["commercialRecordUrl"].clearValidators();
            formGroup["controls"]["commercialRecordUrl"].updateValueAndValidity();

            this.updatedAgentInfo.AgentCertificates.push(this.licensingsShipping);
            this.updatedAgentInfo.AgentCertificates.push(this.taxCard);
            this.updatedAgentInfo.AgentCertificates.push(this.taxAuthorization);
            this.updatedAgentInfo.AgentCertificates.push(this.commercialRecord);
            if (this.taxCardAppendix) {
              this.updatedAgentInfo.AgentCertificates.push(this.taxCardAppendix);
            }
            if (this.otherDocuments) {

              this.updatedAgentInfo.AgentCertificates.push(this.otherDocuments);
            }
            this.updatedAgentEvent.emit(this.updatedAgentInfo);
          }
          this.agentForm.setControl('agentRepresentative', this.getRepresentative(resObj.Data['AgentRepresentatives']));
        }
        else {
          // console.log("Fail");
        }
      });
  }


  //***************Not used****** */
  transformRepresentatvies(agentRepresentatives): any[] {
    let ret = [];
    agentRepresentatives.forEach((key) => {
      ret.push({
        username: key.UserName,
        password: key.Password,
        nationalId: key.NationalId,
      });
    });

    return ret;
  }

  get agentRepresentative() {
    return this.agentForm.get('agentRepresentative') as FormArray;
  }

  // get getTabThreeStatus() {
  //     var valid= this.agentForm.get('agentCertificate').valid;
  //     if (valid) {

  //     }
  // }
  returnCertificates(agentCertificates, certType: number): AgentCertificate {
    let certificate = null;
    agentCertificates.forEach((key) => {
      if (key.CertificateType == certType) {
        certificate = new AgentCertificate();
        certificate.ExpirationDate = key.ExpirationDate;
        certificate.URL = key.URL;
        certificate.NameEN = key.NameEN;
        certificate.NameAR = key.NameAR;
        certificate.Id = key.Id;
        certificate.CertificateType = certType;
      }

    });
    return certificate;
  }

  getRepresentative(agentRepresentatives): any {
    let control = <FormArray>this.agentForm.controls['agentRepresentative'];
    if (this.RequestStatus == ServiceStatus.MoreInformationRequestedFromAgent && this.user.UserId == this.agentId) {
      agentRepresentatives.forEach((key) => {
        control.push(new FormGroup({
          username: new FormControl({ value: key.UserName, disabled: true }),
          password: new FormControl({ value: key.Password, disabled: true }),
          nationalId: new FormControl({ value: key.NationalId, disabled: false }),
          UserId: new FormControl({ value: key.UserId, disabled: false }),
        }));
      });
    }
    else {
      agentRepresentatives.forEach((key) => {
        control.push(new FormGroup({
          username: new FormControl({ value: key.UserName, disabled: true }),
          password: new FormControl({ value: key.Password, disabled: true }),
          nationalId: new FormControl({ value: key.NationalId, disabled: true }),
          UserId: new FormControl({ value: key.UserId, disable: false }),
        }));
      });
    }

    return control;
  }



  selectTab(tabId: number) {
    if (tabId == 1) {
      this.isTabOneSubmitted = true;
      if (!this.validateTabTwo) {
        this.isTabOneValid.emit(true);
        this.agentTabs.tabs[tabId].disabled = false;
        this.agentTabs.tabs[tabId].active = true;
        this.agentTabs.tabs[tabId + 1].disabled = true;
        this.agentTabs.tabs[tabId + 1].active = false;
        const el = document.getElementsByClassName('section-title');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
      else {
        const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }

    }
    else if (tabId == 2) {
      this.isTabTwoSubmitted = true;
      if (this.getValidity()) {
        this.isTabTwoValid.emit(true);
        this.agentTabs.tabs[tabId].disabled = false;
        this.agentTabs.tabs[tabId].active = true;
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        const invalidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }
    }
    else {
      this.agentTabs.tabs[tabId].disabled = false;
      this.agentTabs.tabs[tabId].active = true;

    }
  }

  getValidity() {
    let controls = this.agentForm.get('agentRepresentative') as FormArray;
    if (controls.invalid) {
      this.isTabTwoValid.emit(false);
    }
    else {
      this.isTabTwoValid.emit(true);
    }
    return !controls.invalid;

  }

  //   onChangeNational(event, control) {
  //     let nationalId = event.target.value;
  //     if (control.valid) {
  //       this.agentService.CheckNationalId(nationalId).subscribe((data: ResponseObject) => {
  //         if (!data.Success) {
  //           control.setErrors({ duplicatedNumber: true });
  //         }
  //         else {
  //           control.setErrors(null);
  //           control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
  //           control.updateValueAndValidity();
  //         }

  //       });;
  //     }
  //   }

  onChangeNational(event, control, userId) {
    let nationalId = event.target.value;
    if (control.valid && !userId.value) {
      this.agentService.CheckNationalId(nationalId).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
          control.updateValueAndValidity();
        }
      });
    }
    else if (control.valid && userId.value) {
      this.agentService.CheckUpdateNationalId(nationalId, userId.value).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
          control.updateValueAndValidity();
        }
      });
    }
    else {
      control.setErrors(null);
      control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
      control.updateValueAndValidity();

    }
  }

  deleteRepresentative(index: number) {

    this.agentRepresentative.removeAt(index);
  }


  onChangeUserName(event, control) {

    let UserName = event.target.value;
    this.getRepresentativeUserName.emit(UserName);
    if (UserName) {
      this.membershipService.DuplicateUser(UserName.toLowerCase()).pipe(debounceTime(1000)).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required, Validators.pattern(this.emailRegex)]);
          control.updateValueAndValidity();
        }

      });
    }
  }

  get validateTabTwo() {

    const isvalid = this.agentForm.controls['name'].invalid
      || this.agentForm.controls['displayName'].invalid
      || this.agentForm.controls['address'].invalid
      || this.agentForm.controls['phone1'].invalid
      || this.agentForm.controls['phone2'].invalid
      || this.agentForm.controls['fax'].invalid
      || this.agentForm.controls['contactPerson'].invalid
      || this.agentForm.get('agentCurrency').invalid;
    if (isvalid) {
      this.isTabOneValid.emit(false);
    }
    else {
      this.isTabOneValid.emit(true);
    }
    return isvalid;

  }


  checkOtherDocValidtity() {
    var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
    if (formGroup["controls"]["otherDocumentsExpirationDate"].value) {
      // formGroup["controls"]["otherDocumentsExpirationDate"].setErrors(null);
      if (this.formMode == FormMode.Add || (this.formMode == FormMode.Edit && !this.otherDocuments)) {
        formGroup["controls"]["otherDocumentsUrl"].setValidators([Validators.required]);
        formGroup["controls"]["otherDocumentsUrl"].updateValueAndValidity();
      }

    }
    else {
      formGroup["controls"]["otherDocumentsUrl"].clearValidators();
      formGroup["controls"]["otherDocumentsUrl"].updateValueAndValidity();

    }
  }

  checkAppendixValidtity() {
    var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
    if (formGroup["controls"]["taxCardAppendixExpirationDate"].value) {

      // formGroup["controls"]["taxCardAppendixExpirationDate"].setErrors(null);
      if (this.formMode == FormMode.Add || (this.formMode == FormMode.Edit && !this.taxCardAppendix)) {
        formGroup["controls"]["taxCardAppendixUrl"].setValidators([Validators.required]);
        formGroup["controls"]["taxCardAppendixUrl"].updateValueAndValidity();
      }

    }
    else {
      formGroup["controls"]["taxCardAppendixUrl"].clearValidators();
      formGroup["controls"]["taxCardAppendixUrl"].updateValueAndValidity();

    }
  }
  //    get getTabThreeStatus() {
  //         let invalid= this.agentForm.get('agentCertificate').invalid;
  //         if (invalid) {
  //             this.isTabThreeValid.emit(false);
  //         }
  //         else {
  //             this.isTabThreeValid.emit(true);
  //         }
  //         return invalid;
  //     }

}
